<div class="balance flex--column" data-test="balance">
  <agr-notification-empty
    [isEmpty]="balanceRows$ === undefined"
    [emptyTitle]="'balance.empty-title' | translate"
    [emptyDescription]="'balance.empty-description' | translate"
    emptyImage="assets/images/balance.jpg"
  >
  </agr-notification-empty>

  <ng-container
    class="table-container"
    *ngIf="(isLoading$ | async) === false && balanceRows$ | async as balanceRows"
  >
    <mat-table [dataSource]="datasource" data-test="balance-table">
      <ng-container matColumnDef="deliveryDate">
        <mat-header-cell *matHeaderCellDef>{{
          'balance.delivery-date' | translate
        }}</mat-header-cell>
        <mat-cell *matCellDef="let element">
          <span *ngIf="element.deliverySource !== 'Manual'; else manualBadge">
            {{ element.deliveryDate | agrDate: 'dd-MM-yyyy' }}
          </span>
          <ng-template #manualBadge>
            <mat-chip-listbox>
              <mat-chip-option
                selectable="false"
                #tooltip="matTooltip"
                [matTooltip]="'balance.manual-add' | translate"
                matTooltipPosition="above"
                >{{ element.deliveryDate | agrDate: 'dd-MM-yyyy' }}</mat-chip-option
              >
            </mat-chip-listbox>
          </ng-template>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="deliveryNumber">
        <mat-header-cell *matHeaderCellDef>{{
          'balance.delivery-number' | translate
        }}</mat-header-cell>
        <mat-cell *matCellDef="let element" data-test="balance-table__deliveryNumber">
          {{ element.externalDeliveryId }}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="invoiceDate">
        <mat-header-cell *matHeaderCellDef>{{
          'balance.invoice-date' | translate
        }}</mat-header-cell>
        <mat-cell *matCellDef="let element">
          <span>
            {{ element.invoiceDate | agrDate: 'dd-MM-yyyy' }}
          </span>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="invoiceNumber">
        <mat-header-cell *matHeaderCellDef>{{
          'balance.invoice-number' | translate
        }}</mat-header-cell>
        <mat-cell *matCellDef="let element" data-test="balance-table__invoiceNumber">
          {{ element.externalInvoiceId }}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="barnName">
        <mat-header-cell *matHeaderCellDef>{{ 'balance.barn-name' | translate }}</mat-header-cell>
        <mat-cell *matCellDef="let element" data-test="balance-table__barnName">
          {{ element.barnName }}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="productTitle">
        <mat-header-cell *matHeaderCellDef>{{ 'balance.product' | translate }}</mat-header-cell>
        <mat-cell *matCellDef="let element" data-test="balance-table__productTitle">
          {{ element.productTitle }}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="quantity">
        <mat-header-cell *matHeaderCellDef class="cell--align-right">
          {{ 'balance.quantity' | translate }}
        </mat-header-cell>
        <mat-cell
          *matCellDef="let element"
          class="cell--align-right"
          data-test="balance-table__quantity"
        >
          {{ element.quantity | agrNumber }}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="remainder">
        <mat-header-cell *matHeaderCellDef class="cell--align-right">
          {{ 'balance.remainder' | translate }}
        </mat-header-cell>
        <mat-cell
          *matCellDef="let element"
          class="cell--input-cell edit-remainder"
          data-test="balance-table__remainder"
        >
          <span *ngIf="isFinalBalance" class="readonly-remainder">
            {{ element.remainder | agrNumber }}
          </span>
          <ng-container *ngIf="element.deliverySource !== 'manual' && !isFinalBalance">
            <label class="cdk-visually-hidden" for="balance-remainder-{{ element.balanceRowId }}">
              {{ 'balance.remainder' | translate }}
            </label>
            <mat-form-field class="cell--input-field" floatLabel="auto" subscriptSizing="dynamic">
              <input
                id="balance-remainder-{{ element.balanceRowId }}"
                [placeholder]="'balance.remainder' | translate"
                matInput
                agrNumber
                class="cell--input-field"
                [step]="1"
                [value]="element.remainder"
                [(ngModel)]="element.remainder"
                (ngModelChange)="remainderChanged($event, element)"
                [remainderValidator]="validateRemainder(element)"
              />
            </mat-form-field>
          </ng-container>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="consumption">
        <mat-header-cell *matHeaderCellDef class="show-on-mobile cell--align-right">
          {{ 'balance.consumption' | translate }}
        </mat-header-cell>
        <mat-cell *matCellDef="let element" class="show-on-mobile cell--align-right">
          {{ calculateConsumption(element) | agrNumber }}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="price">
        <mat-header-cell *matHeaderCellDef class="show-on-mobile cell--align-right">
          {{ 'balance.price' | translate }}
        </mat-header-cell>
        <mat-cell
          *matCellDef="let element"
          class="show-on-mobile cell--align-right"
          data-test="balance-table__price"
        >
          {{ element.price | agrCurrency: element.currency }}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="delete">
        <mat-header-cell *matHeaderCellDef class="show-on-mobile cell--align-right">
        </mat-header-cell>
        <mat-cell *matCellDef="let element" class="show-on-mobile cell--align-right">
          <button
            *ngIf="!isFinalBalance"
            mat-icon-button
            (click)="delete(element)"
            data-test="balance-table__delete-item"
          >
            <mat-icon>delete</mat-icon>
          </button>
        </mat-cell>
      </ng-container>

      <mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></mat-header-row>
      <mat-row
        *matRowDef="let row; columns: displayedColumns"
        [ngClass]="{ 'first-row': row.deliverySource === 'start' }"
      ></mat-row>
    </mat-table>

    <ng-container *ngIf="!hasDayOldChicks && !hasBalanceRows">
      <agr-notification-empty
        [isEmpty]="(hasDayOldChicks$ | async) === false"
        [emptyTitle]="'balance.empty-day-old-chick-title' | translate"
        [emptyDescription]="'balance.empty-day-old-chick-description' | translate"
        emptyImage="assets/images/balance.jpg"
      >
      </agr-notification-empty>

      <agr-notification-empty
        [isEmpty]="(hasDayOldChicks$ | async) === true"
        [emptyTitle]="'balance.empty-title' | translate"
        [emptyDescription]="'balance.empty-description' | translate"
        emptyImage="assets/images/balance.jpg"
      >
      </agr-notification-empty>
    </ng-container>
  </ng-container>

  <div
    class="flex--column wrapper--spacing-horizontal wrapper--spacing-vertical"
    *ngIf="hasDayOldChicks || hasBalanceRows"
  >
    <div class="mat-button-row">
      <button
        type="button"
        mat-flat-button
        color="primary"
        (click)="recalculate()"
        [disabled]="remainderErrors.length > 0 || isFinalBalance"
        data-test="balance__recalculate"
      >
        {{ 'balance.recalculate' | translate }}
      </button>
      <button
        type="button"
        mat-flat-button
        color="primary"
        class="button--float-right mat-accent"
        [disabled]="isFinalBalance"
        (click)="addManualDelivery()"
      >
        <mat-icon>add</mat-icon>{{ 'balance.add-manual-delivery' | translate }}
      </button>
      <label class="cdk-visually-hidden" for="delivery-csv-input">
        {{ 'csv-import.upload' | translate }}
      </label>
      <input
        #deliveryCsvInput
        id="delivery-csv-input"
        type="file"
        accept=".csv,text/csv"
        hidden
        (change)="uploadDeliveryCsv($event)"
        data-test="balance__upload-csv-input"
      />
      <button
        type="button"
        mat-flat-button
        color="primary"
        class="button--float-right mat-accent"
        [disabled]="isFinalBalance"
        (click)="deliveryCsvInput.click()"
        data-test="balance__upload-csv"
      >
        <mat-icon>upload_file</mat-icon>{{ 'csv-import.upload' | translate }}
      </button>
      <button
        type="button"
        mat-flat-button
        color="primary"
        class="button--float-right mat-accent"
        (click)="downloadDeliveryCsvTemplate()"
        data-test="balance__download-csv-template"
      >
        <mat-icon>file_download</mat-icon>{{ 'csv-import.download-template' | translate }}
      </button>
      <button
        type="submit"
        mat-flat-button
        color="primary"
        *ngIf="balanceRows$ !== undefined && !isFinalBalance"
        (click)="saveBalance()"
      >
        {{ 'save' | translate }}
      </button>
      <button
        type="button"
        mat-flat-button
        color="primary"
        *ngIf="balanceRows$ !== undefined && isFinalBalance"
        (click)="editBalance()"
      >
        {{ 'balance.edit-balance' | translate }}
      </button>
      <button
        mat-flat-button
        color="primary"
        *ngIf="balanceRows$ !== undefined && !isFinalBalance && hasMultipleBarns"
        (click)="openBarnDistributionDialog()"
        data-test="balance-table__flock-allocation-button"
      >
        <span> {{ 'balance.barn-distribution.flock-allocation' | translate }}</span>
      </button>
    </div>
    <div class="layout--padding-right">
      <div class="notification notification-error" *ngFor="let error of remainderErrors">
        <mat-icon>error</mat-icon>
        {{ error.message | translate }}
      </div>
    </div>
  </div>

  <div
    class="spacing--margin-horizontal spacing--margin-vertical"
    *ngIf="!isFinalBalance && !hasEmptyBarns"
  >
    <agr-extended-notification
      notificationType="info"
      [title]="'balance.not-finalized.title' | translate"
      [message]="'balance.not-finalized.message' | translate"
      [actionText]="'balance.save-and-finalize' | translate"
      (action)="saveFinalizedBalance()"
    >
    </agr-extended-notification>
  </div>

  <div class="spacing--margin-horizontal spacing--margin-vertical" *ngIf="hasEmptyBarns">
    <agr-extended-notification
      notificationType="error"
      [title]="'balance.has-empty-barns.title' | translate"
      [message]="'balance.has-empty-barns.message' | translate"
      [actionText]="'balance.recalculate' | translate"
      (action)="recalculate()"
    >
    </agr-extended-notification>
  </div>

  <ng-container
    class="table-container"
    *ngIf="(isLoading$ | async) === false && balanceRows$ | async as balanceRows"
  >
    <app-balance-summary
      [balance]="balanceRows"
      [cycle]="cycle$ | async"
      (allocationChanged)="updateBalanceRows($event)"
      *ngIf="!!balanceRows && balanceRows.length > 0"
    ></app-balance-summary>
  </ng-container>
</div>
